<template>
  <b-row class="match-height">
    <b-col
      v-show="!details"
      cols="12"
    >
      <video-table-daily
        :video-details="videoDetails"
        :on-progress="videoDetailsOnProgress"
        :video-id="videoId"
        @detailsSelected="openDetails"
      />
    </b-col>
    <b-col
      v-show="details"
      cols="12"
    >
      <video-details-daily
        :details="details"
        @closeDetails="closeDetails"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
    BRow,
    BCol,
} from 'bootstrap-vue'

import usAppConfig from '@core/app-config/useAppConfig'
import { executeQuery, resetQueries } from '@/coreApi/coreApiDataset'
import coreApiDataIndex from '@/coreApi/coreApiDataIndex'
import { getCoreApiData, getCoreApiDataOnProgress } from '@/coreApi/coreApi'
import { coreApiPageDateRangeFilterObject } from '@/coreApi/filters/coreApiPageDateRangeFilter'
import { getProjectCoreProjectId, getProjectFilterObject } from '@/coreApi/filters/coreApiFilterHelper'
import VideoTableDaily from '@/views/components/tables/video/VideoTableDaily.vue'
import VideoDetailsDaily from '@/views/components/videoDetails/VideoDetailsDaily.vue'
import { coreApiDetailFilterObject } from '@/coreApi/filters/coreApiDetailFilter'

// eslint-disable-next-line no-unused-vars,import/no-extraneous-dependencies
const moment = require('moment')

export default {
    components: {
        VideoDetailsDaily,
        VideoTableDaily,
        BRow,
        BCol,
    },
    data() {
        return {
            longCacheTime: 86410,
            details: null,
            videoId: null,
            projectId: null,
            filter: null,
        }
    },
    watch: {
        $route() {
            this.initQueries()
            this.intiDetails()
        },
    },
    created() {
        this.initQueries()
        this.intiDetails()
    },
    methods: {
        isMobile() {
            return window.innerWidth < 768
        },
        initQueries() {
            const projectFilterObject = getProjectFilterObject()
            const pageFilter = projectFilterObject.getFilterQueryObject()
            const pageDateRangeFilter = coreApiPageDateRangeFilterObject.getFilterQueryObject()
            const filterKey = JSON.stringify(pageFilter) + JSON.stringify(pageDateRangeFilter)
            if (this.projectId !== getProjectCoreProjectId() || this.filter !== filterKey) {
                this.projectId = getProjectCoreProjectId()
                this.filter = filterKey
                this.runQuery(getProjectCoreProjectId(), pageFilter, pageDateRangeFilter)
            }
        },
        getFilterObject() {
            const projectFilterObject = getProjectFilterObject()
            return projectFilterObject.getFilterList()
        },
        runQuery(projectId, pageFilter, pageDateRangeFilter) {
            let projectIdBase = projectId
            if (projectIdBase.indexOf('-') > -1) {
                projectIdBase = projectIdBase.slice(0, projectIdBase.indexOf('-'))
            }
            pageFilter.push({ key: 'projectId', value: projectId })

            const startDate = moment().subtract(pageDateRangeFilter.skip, 'days')
            const startDateString = startDate.format('YYYY-MM-DD')
            const endDate = startDate.add(pageDateRangeFilter.take - 1, 'days')
            const endDateString = endDate.format('YYYY-MM-DD')

            let timeout = this.longCacheTime
            if ((pageDateRangeFilter.skip === 0) || (pageDateRangeFilter.skip - pageDateRangeFilter.take === -1)) {
                timeout = 180
            } else if (endDateString === moment().subtract(1, 'days').format('YYYY-MM-DD')) {
                // eslint-disable-next-line radix
                if (parseInt(moment().format('HH')) < 1) {
                    // Yesterday created at 00.32
                    timeout = 300
                }
            }

            // Daily Video Details - dailyVideoDetails
            executeQuery(
                coreApiDataIndex.d1,
                {
                    startDate: startDateString,
                    endDate: endDateString,
                    timeout,
                    request_nodes: [
                        {
                            project_id: projectIdBase,
                            alias: 'dailyVideoDetails',
                            options: [
                                {
                                    alias: 'dailyVideoDetails',
                                    return_id: 'dailyVideoDetails',
                                    filter_values: pageFilter,
                                    offset: 0,
                                    limit: 200,
                                },
                                {
                                    alias: 'videos',
                                    filter_date_indicator: pageDateRangeFilter,
                                },
                            ],
                        },
                    ],
                },
            )
        },
        intiDetails() {
            const projectFilterObject = getProjectFilterObject()
            const detailsObject = projectFilterObject.getFilterDetails()
            if (detailsObject) {
                if (
                    !this.details
                    && detailsObject.videoId
                ) {
                    this.videoId = detailsObject.videoId
                }
            } else {
                this.closeDetails()
            }
        },
        openDetails(obj) {
            if (obj.details && obj.details.videoId) {
                const filters = { details: { videoId: obj.details.videoId } }
                const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
                if (newPath !== this.$route.fullPath) {
                    this.$router.push(newPath)
                }
                this.videoId = obj.details.videoId
            } else {
                this.videoId = null
            }
            this.details = obj.details
        },
        closeDetails() {
            const filters = { details: null }
            const newPath = coreApiDetailFilterObject.getFilterUrl(filters)
            if (newPath !== this.$route.fullPath) {
                this.$router.push(newPath)
            }
            this.details = null
            this.videoId = null
        },
    },
    setup() {
        return {
            videoDetails: getCoreApiData(coreApiDataIndex.d1),
            videoDetailsOnProgress: getCoreApiDataOnProgress(coreApiDataIndex.d1),
            skinMode: usAppConfig().skin,
        }
    },
    beforeRouteLeave(to, from, next) {
        this.closeDetails()
        resetQueries()
        next()
    },
}
</script>

<style>

</style>
